import complaints from '@/components/complaints/Complaints'
import complaintsNew from '@/components/complaints/ComplaintsNew'
import complaintsEdit from '@/components/complaints/ComplaintsEdit'
export default [
  {
    path: '/complaints',
    name: 'complaints',
    component: complaints,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/complaints/new',
    name: 'complaintsNew',
    component: complaintsNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/complaints/:id/edit',
    name: 'complaintsEdit',
    component: complaintsEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/complaintsRoutes.js